/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';
import SkeletonPlaceholder from '../SkeletonPlaceholder/SkeletonPlaceholder.js';

const AISkeletonPlaceholder = _ref => {
  let {
    className,
    ...other
  } = _ref;
  const prefix = usePrefix();
  const AISkeletonPlaceholderClasses = cx({
    className,
    [`${prefix}--skeleton__placeholder--ai`]: true
  }, className);
  return /*#__PURE__*/React__default.createElement(SkeletonPlaceholder, _extends({
    className: AISkeletonPlaceholderClasses
  }, other));
};
AISkeletonPlaceholder.propTypes = {
  /**
   * Add a custom class to the component
   * to set the height and width
   */
  className: PropTypes.string
};

export { AISkeletonPlaceholder as default };
